module.exports = __webpack_public_path__ + "static/img/icon_wailian.9be446aa.png";